import {
  useController,
  type FieldValues,
  type UseControllerProps,
} from "react-hook-form";
import { Datepicker } from "@components/inputs/Datepicker/Datepicker";
import { type IInputProps } from "@components/inputs/Input/Input";

export type TFormDatepickerProps<T extends FieldValues> = IInputProps &
  UseControllerProps<T>;

export const FormDatepicker = <T extends FieldValues>({
  name,
  control,
  ...rest
}: TFormDatepickerProps<T>) => {
  const controller = useController({
    name,
    control,
  });

  const {
    field,
    fieldState: { error },
  } = controller;

  const { ref: fieldRef, ...fieldRest } = field;

  return (
    <Datepicker
      {...rest}
      {...fieldRest}
      ref={fieldRef}
      error={error?.message}
      {...(rest.disabled ? { disabled: true } : {})}
    />
  );
};
